  jQuery(function($){
    var $prevButton = $('.featured-promotions__nav--prev');
    var $nextButton = $('.featured-promotions__nav--next');
    
    var carousel_collection_list= $('.collection-list-slider');
    
    $(carousel_collection_list).flickity({
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      watchCSS: true,
      initialIndex: 0,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false, // advance cells every 3 seconds
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_collection_list).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_collection_list).flickity('next');
        });
        }
      }
    });

    var carousel_blogs = $('.blog-inner-container');
    
    $(carousel_blogs).flickity({
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      watchCSS: true,
      initialIndex: 0,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false, // advance cells every 3 seconds
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_blogs).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_blogs).flickity('next');
        });
        }
      }
    });

   var carousel_subcollections = $('.list-collection-wrapper');
    
    $(carousel_subcollections).flickity({
      freeScroll: true,
      imagesLoaded: true,
      contain: true,
      wrapAround: true,
      draggable: true,
      cellAlign: 'left',
      watchCSS: true,
      initialIndex: 0,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false, // advance cells every 3 seconds
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_subcollections).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_subcollections).flickity('next');
        });
        }
      }
    });

    
    var carousel_product_promotions_loop_slider_colection = $('.product-loop-slider-promotions');
    var $prevButton = $('.featured-promotions__nav--prev_collection');
    var $nextButton = $('.featured-promotions__nav--next_collection');
     $(carousel_product_promotions_loop_slider_colection).flickity({
        // options
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: false,// advance cells every 3 seconds
        on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_product_promotions_loop_slider_colection).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_product_promotions_loop_slider_colection).flickity('next');
        });
        }
      }
        
    });

     var carousel_product_promotions_loop_slider = $('.complete-the-look-slider');
    var $prevButton = $('.complete_the_look__nav--prev');
    var $nextButton = $('.complete_the_look__nav--next');
     $(carousel_product_promotions_loop_slider).flickity({
        // options
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: false,// advance cells every 3 seconds
        on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_product_promotions_loop_slider).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_product_promotions_loop_slider).flickity('next');
        });
        }
      }
        
    });

     var carousel_product_loop_slider = $('.product-loop-slider');
     $(carousel_product_loop_slider).flickity({
        // options
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: false,// advance cells every 3 seconds
        on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_product_loop_slider).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_product_loop_slider).flickity('next');
        });
        }
      }
        
    });

    $('#ptw-gift-needed').click(function() {
        $("#txtAge").toggle(this.checked);
    });

    // Automatically simulate additional taps on the mobile search field until Snize renders its overlay once.
    var MOBILE_SEARCH_SELECTOR = '.mobile-header__search-input';
    var SNIZE_CONTAINER_SELECTOR = '.snize-ac-results-content';
    var SNIZE_MAX_ATTEMPTS = 5;
    var SNIZE_RETRY_DELAY = 180;
    var snizeAutoTapInProgress = false;
    var snizeAutoTapTimer = null;
    var snizeLatestValue = '';

    function isMobileViewport() {
      if (window.PXUTheme && window.PXUTheme.media_queries && window.PXUTheme.media_queries.large) {
        return window.PXUTheme.media_queries.large.matches === false;
      }
      return window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;
    }

    function snizeModalIsVisible() {
      var $container = $(SNIZE_CONTAINER_SELECTOR);
      if (!$container.length) {
        return false;
      }
      if ($container.hasClass('snize-hidden')) {
        return false;
      }
      return $container.is(':visible');
    }

    function focusSnizeMobileInput(value) {
      var $snizeInput = $('#snize-mobile-search-input');
      if (!$snizeInput.length) {
        $snizeInput = $(SNIZE_CONTAINER_SELECTOR).find('.snize-input-style').first();
      }
      if ($snizeInput.length) {
        if (typeof value === 'string') {
          $snizeInput.val(value);
          $snizeInput.trigger('input');
        }
        $snizeInput.focus();
        if ($snizeInput[0] && $snizeInput[0].setSelectionRange) {
          var caretPosition = $snizeInput.val().length;
          $snizeInput[0].setSelectionRange(caretPosition, caretPosition);
        }
      }
    }

    function dispatchNativeClick(el) {
      if (!el) {
        return;
      }
      ['pointerdown', 'mousedown', 'touchstart', 'pointerup', 'mouseup', 'touchend', 'click'].forEach(function(evtName) {
        var eventInit = { bubbles: true, cancelable: true, view: window };
        if (typeof PointerEvent !== 'undefined' && evtName.indexOf('pointer') === 0) {
          el.dispatchEvent(new PointerEvent(evtName, eventInit));
        } else if (typeof TouchEvent !== 'undefined' && (evtName === 'touchstart' || evtName === 'touchend')) {
          try {
            el.dispatchEvent(new TouchEvent(evtName, eventInit));
          } catch (error) {
            // TouchEvent may not be constructible on desktop browsers; fallback to MouseEvent.
            el.dispatchEvent(new MouseEvent(evtName === 'touchstart' ? 'mousedown' : 'mouseup', eventInit));
          }
        } else {
          el.dispatchEvent(new MouseEvent(evtName, eventInit));
        }
      });
    }

    function stopAutoTap(success) {
      clearInterval(snizeAutoTapTimer);
      snizeAutoTapTimer = null;
      snizeAutoTapInProgress = false;
      if (success) {
        focusSnizeMobileInput(snizeLatestValue);
      }
    }

    function startAutoTap($input) {
      if (!$input || !$input.length) {
        return;
      }
      var attempts = 0;
      snizeAutoTapInProgress = true;
      snizeAutoTapTimer = setInterval(function() {
        if (snizeModalIsVisible()) {
          stopAutoTap(true);
          return;
        }
        if (attempts >= SNIZE_MAX_ATTEMPTS) {
          stopAutoTap(false);
          return;
        }
        attempts += 1;
        dispatchNativeClick($input[0]);
      }, SNIZE_RETRY_DELAY);
    }

    $(document).on('input', MOBILE_SEARCH_SELECTOR, function() {
      if (!isMobileViewport()) {
        return;
      }
      var value = $(this).val();
      if (!value || !value.trim()) {
        return;
      }
      snizeLatestValue = value;
      if (snizeAutoTapInProgress) {
        return;
      }
      startAutoTap($(this));
    });

    
  });

/* Icon bar */

/* Icon bar */
var elem = document.querySelector('.icon-bars');
var flkty = new Flickity( elem, {
  wrapAround: true,
  pageDots: false,
  initialIndex: 1,
  fade: true,
  watchCSS: true,
  prevNextButtons: false,
  accessibility: true, //true by default
  autoPlay: true // advance cells every 3 seconds
});

/* Scroll to Top */
function scrollTop() {
  // 500 -> This is the value in px of the distance to be scrolled for the 'scroll-to-top' button to show-up
  if ($(window).scrollTop() > 500) {
    $(".backToTopBtn").addClass("active");
  } else {
    $(".backToTopBtn").removeClass("active");
  }
}
$(function () {
  // show and hide btn
  scrollTop();
  $(window).on("scroll", scrollTop);

  // body scroll on btn click
  $(".backToTopBtn").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1);
    return false;
  });
});

$('.sub-collections_slider').flickity({
        // options
  freeScroll: true,
  imagesLoaded: true,
  draggable: true,
  cellAlign: 'center',
  wrapAround: true,
  prevNextButtons: false,
  pageDots: false,
  autoPlay: true
});

$('.sub_collection_mobile').flickity({
        // options
  freeScroll: true,
  imagesLoaded: true,
  draggable: true,
  cellAlign: 'center',
  wrapAround: true,
  prevNextButtons: false,
  pageDots: false,
  autoPlay: true
});
